export const textfield = {
    base: {
        background: "#ccffff",
        border: "thin solid #191919",
        color: "black",
    }
}